"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$sharedQueries = exports.initialState = void 0;
const ramda_1 = require("ramda");
const constants_1 = require("./constants");
const events_1 = require("./events");
exports.initialState = {};
exports.$sharedQueries = constants_1.sharedQueriesDomain.createStore(exports.initialState, {
    name: `${constants_1.domainKey}/stores/sharedQueries`,
    sid: `${constants_1.domainKey}/stores/sharedQueries`
});
exports.$sharedQueries.on(events_1.shareQuery, (state, payload) => {
    const { queryHash, queryState } = payload;
    return (0, ramda_1.assoc)(queryHash, queryState, state);
});
exports.$sharedQueries.on(events_1.deleteSharedQuery, (state, payload) => {
    const { queryHash } = payload;
    return (0, ramda_1.dissoc)(queryHash, state);
});
